import skeleton from "./skeleton"
import shipment from "./shipment"

// Only kept shipment and user management navigation after refactoring
export default [...skeleton, ...shipment]
